import axios from 'axios';
import { ElMessage } from 'element-plus';
import sysConfig from "@/config";
import tool from '@/utils/tool';
import router from '@/router';
axios.defaults.baseURL = process.env.VUE_APP_BASE_API
axios.defaults.timeout = sysConfig.TIMEOUT
let redirectingToLogin = false

function rejectResponse(response, originalError) {
	const data = response && response.data || {}
	const status = Number(data.code || (response && response.status))
	const requestConfig = (originalError && originalError.config) || (response && response.config) || {}
	// 兼容旧后端：me/menus 只要求登录，它们返回 403 表示会话失效。
	const sessionEndpoint = /(?:^|\/)oms\/(me|menus)(?:[?#]|$)/.test(requestConfig.url || '')
	const sessionExpired = status === 401 || (status === 403 && sessionEndpoint)
	const message = sessionExpired ? '登录失效，请重新登录' :
		(data.message || (status === 403 ? '暂无访问权限' : '请求服务器无响应'))
	const error = originalError instanceof Error ? originalError : new Error(message)
	error.message = message
	error.response = response
	error.status = sessionExpired ? 401 : status
	if (sessionExpired) {
		tool.cookie.remove('Admin-Token')
		if (!redirectingToLogin) {
			ElMessage.error(message)
			redirectingToLogin = true
			Promise.resolve(router.replace({ path: '/login' })).catch(() => {}).finally(() => {
				redirectingToLogin = false
			})
		}
	} else {
		ElMessage.error(message)
	}
	return Promise.reject(error)
}
// HTTP request 拦截器
axios.interceptors.request.use(
	(config) => {
		let token = tool.cookie.get("Admin-Token");
		if(token){
			config.headers[sysConfig.TOKEN_NAME] = token
		}
		// if (config.headers['Content-Type']) config.headers['Content-Type'] = config.headers['Content-Type']
		if(!sysConfig.REQUEST_CACHE && config.method == 'get'){
			config.params = config.params || {};
			config.params['_'] = new Date().getTime();
		}
		Object.assign(config.headers, sysConfig.HEADERS)
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// HTTP response 拦截器
axios.interceptors.response.use(
	(response) => {
		if ([401, 403].includes(Number(response.data.code))) return rejectResponse(response)
		if (ElMessage) ElMessage.closeAll() // 防止多次弹框
		if (response.data.code == 404) {
			ElMessage.error("Status:404，正在请求不存在的服务器记录");
		} else if (response.data.code == 500) {
			ElMessage.error(response.data.message || "Status:500，服务器发生错误");
		}
		return response;
	},
	(error) => {
			if (ElMessage) ElMessage.closeAll() // 防止多次弹框
			return rejectResponse(error.response, error);
	}
);

var http = {
	/** get 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} params
	 * @param  {参数} config
	 */
	get: function(url, params={}, config={}) {
		axios.defaults.baseURL = url.includes('mc') ? process.env.VUE_APP_MC_API : process.env.VUE_APP_BASE_API
		return new Promise((resolve, reject) => {
			axios({
				method: 'get',
				url: url,
				params: params,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** post 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} data
	 * @param  {参数} config
	 */
	post: function(url, data={}, config={}) {
		axios.defaults.baseURL = url.includes('mc') ? process.env.VUE_APP_MC_API : process.env.VUE_APP_BASE_API
		return new Promise((resolve, reject) => {
			axios({
				method: 'post',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** put 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} data
	 * @param  {参数} config
	 */
	put: function(url, data={}, config={}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'put',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** patch 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} data
	 * @param  {参数} config
	 */
	patch: function(url, data={}, config={}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'patch',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** delete 请求
	 * @param  {接口地址} url
	 * @param  {请求参数} data
	 * @param  {参数} config
	 */
	delete: function(url, data={}, config={}) {
		return new Promise((resolve, reject) => {
			axios({
				method: 'delete',
				url: url,
				data: data,
				...config
			}).then((response) => {
				resolve(response.data);
			}).catch((error) => {
				reject(error);
			})
		})
	},

	/** jsonp 请求
	 * @param  {接口地址} url
	 * @param  {JSONP回调函数名称} name
	 */
	jsonp: function(url, name='jsonp'){
		return new Promise((resolve) => {
			var script = document.createElement('script')
			var _id = `jsonp${Math.ceil(Math.random() * 1000000)}`
			script.id = _id
			script.type = 'text/javascript'
			script.src = url
			window[name] =(response) => {
				resolve(response)
				document.getElementsByTagName('head')[0].removeChild(script)
				try {
					delete window[name];
				}catch(e){
					window[name] = undefined;
				}
			}
			document.getElementsByTagName('head')[0].appendChild(script)
		})
	}
}

export default http;
